import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AppProvider } from "./context/AppContext";
import SmoothScroll from "./components/SmoothScroll";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import Atelier from "./pages/Atelier";
import GravureLaser from "./pages/GravureLaser";
import Sublimation from "./pages/Sublimation";
import Legal from "./pages/Legal";
import Account from "./pages/Account";
import Realisations from "./pages/Realisations";
import CartPage from "./pages/CartPage";
import PaymentSuccess from "./pages/PaymentSuccess";
import Login from "./pages/Login";
import Admin from "./pages/Admin";

function Layout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <div className="grain" aria-hidden="true" />
      <AppProvider>
        <HelmetProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Toaster position="top-center" richColors />
            <Routes>
              <Route path="/" element={<Layout><Home /></Layout>} />
              <Route path="/catalogue" element={<Layout><Catalog /></Layout>} />
              <Route path="/produit/:id" element={<Layout><ProductDetail /></Layout>} />
              <Route path="/atelier" element={<Layout><Atelier /></Layout>} />
              <Route path="/gravure-laser" element={<Layout><GravureLaser /></Layout>} />
              <Route path="/sublimation" element={<Layout><Sublimation /></Layout>} />
              <Route path="/legal/:slug" element={<Layout><Legal /></Layout>} />
              <Route path="/compte" element={<Layout><Account /></Layout>} />
              <Route path="/produits" element={<Layout><Realisations /></Layout>} />
              <Route path="/realisations" element={<Navigate to="/produits" replace />} />
              <Route path="/panier" element={<Layout><CartPage /></Layout>} />
              <Route path="/payment/success" element={<Layout><PaymentSuccess /></Layout>} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </SmoothScroll>
        </BrowserRouter>
        </HelmetProvider>
      </AppProvider>
    </div>
  );
}

export default App;
